import { useState, useEffect } from 'react';
import Resizer from 'react-image-file-resizer';
import moment from 'moment-timezone';
import UnifiedDatePicker from '../Calendario';

const PaqueteForm = ({ viviendas, paquete }) => {

	const [foto_paquete_url, setfoto_paquete_url] = useState(null);
	const [foto_entrega_url, setfoto_entrega_url] = useState(null);
	const [fechaLlegada, setFechaLlegada] = useState(null);
	const [fechaEntrega, setFechaEntrega] = useState(null);

	useEffect(() => {
		(async () => {
			if (paquete) {
				await colocaValor('entrega_empresa', paquete.empresa_paqueteria);
				await colocaValor('entrega_nombre_residente', paquete.nombre_residente);
				await colocaValor('entrega_nombre_recibo', paquete.nombre_recibo);

				const llegadaTexto = moment(paquete.fecha_llegada).format('DD/MM/YYYY [-] hh:mm A');
				const llegadaISO = moment(paquete.fecha_llegada).format('YYYY-MM-DDTHH:mm');
				await colocaValor('entrega_fecha_llegada', llegadaTexto);
				setFechaLlegada(llegadaISO);

				await colocaValor('entrega_comentarios', paquete.comentarios);
				setfoto_paquete_url(paquete.foto_paquete_url);
				await colocaValor('entrega-unidad', paquete.numero_registro);

				if (paquete.fecha_entrega) {
					setFechaEntrega(new Date(paquete.fecha_entrega));
				} else {
					setFechaEntrega(new Date());
				}

				if (paquete.nombre_recibo) {
					await colocaValor('entrega_nombre_recibe', paquete.nombre_recibo);
				};

				if (paquete.foto_entrega_url) {
					setfoto_entrega_url(paquete.foto_entrega_url);
				};
			};
		})();
	}, [paquete]);

	async function colocaValor(id, valor) {
		const input = document.getElementById(id);
		if (input) {
			input.value = valor;
		};
	};

	async function changePaqueteImagen(event) {
		let file = event.target;
		if (file && file.files[0]) {
			
			const maxWidth = 1024;
			const maxHeight = 640;
			const quality = 85;

			Resizer.imageFileResizer(
				file.files[0],
				maxWidth,
				maxHeight,
				'JPEG',
				quality,
				0,
				async uri => {
					await setfoto_entrega_url(uri);
				},
				'base64'
			);
		}
	};

	const llegada = new Date(fechaLlegada);
	const esMismoDia = fechaEntrega && moment(fechaEntrega).isSame(llegada, 'day');

	const minTime = esMismoDia ? llegada : moment().startOf('day').toDate();
	const maxTime = fechaEntrega && moment(fechaEntrega).isSame(moment(), 'day')
    	? new Date()
    	: moment().endOf('day').toDate();

	return (
		<div className="tw-grid tw-grid-cols-[3fr_1fr] tw-w-full tw-items-center tw-gap-5">
			<div className="tw-w-full tw-space-y-1.5 tw-text-xs">
				<div className="tw-flex tw-flex-col">
					<label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Vivienda:</label>
					<select
						id="entrega-unidad"
						name="entrega-unidad"
						value={paquete?.id_vivienda || ""}
						className="input-edit-sm tw-text-left"
						disabled
					>
						<option value="">Selecciona una vivienda</option>

						{viviendas.map((vivienda) => (
							<option
									key={vivienda.id_vivienda}
									value={vivienda.id_vivienda}
							>
								{vivienda.numero_registro}
							</option>
						))}
					</select>
				</div>

				<div className="tw-flex tw-flex-col">
					<label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Empresa:</label>
					<input
						className="input-edit-sm tw-text-left"
						type="text"
						name="entrega_empresa"
						id="entrega_empresa"
						autoComplete="off"
						required
						disabled
					/>
				</div>

				<div className="tw-flex tw-flex-col">
					<label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Destinatario:</label>
					<input
						className="input-edit-sm tw-text-left"
						type="text"
						name="entrega_nombre_residente"
						id="entrega_nombre_residente"
						autoComplete="off"
						required
						disabled
					/>
				</div>

				<div className="tw-flex tw-flex-col">
					<label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Fecha llegada:</label>
					<input
						id="entrega_fecha_llegada"
						name="entrega_fecha_llegada"
						className="input-edit-sm tw-text-left"
						type="text"
						autoComplete="off"
						required
						disabled
						readOnly
					/>
				</div>

				<div className="tw-flex tw-flex-col">
					<label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Nombre recibe:</label>
					<input
						id="entrega_nombre_recibe"
						name="entrega_nombre_recibe"
						className="input-edit-sm tw-text-left"
						type="text"
						autoComplete="off"
						disabled={paquete.fecha_entrega}
						required
					/>
				</div>

				<div className="tw-flex tw-flex-col">
					<label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Fecha entrega:</label>
					<div className="tw-flex tw-flex-col">
						<UnifiedDatePicker
							selected={fechaEntrega}
							onChange={(date) => {
        						if (!date) return;

        						const nuevaFecha = moment(date);
        						const fechaMinima = moment(llegada);
        						const fechaMaxima = moment();

        						if (nuevaFecha.isBefore(fechaMinima, 'day')) return;
        						if (nuevaFecha.isAfter(fechaMaxima, 'day')) return;

        						if (nuevaFecha.isSame(fechaMinima, 'day') && nuevaFecha.isBefore(fechaMinima)) {
            						date = moment(date)
                					.hour(fechaMinima.hour())
                					.minute(fechaMinima.minute())
                					.second(0)
                					.toDate();
        						}

        						if (moment(date).isAfter(moment())) return;

        						setFechaEntrega(date);
    						}}
							includeTime={true}
							dateFormat="dd/MM/yyyy HH:mm"
							minDate={new Date(fechaLlegada)}
							maxDate={new Date()}
							minTime={minTime}
							maxTime={maxTime}
							placeholderText="DD/MM/YYYY HH:mm"
							className="input-edit-sm tw-text-left tw-w-full"
							required
						/>

						<input
							id="entrega_fecha_entrega"
							name="entrega_fecha_entrega"
							type="hidden"
							value={fechaEntrega ? moment(fechaEntrega).format("YYYY-MM-DDTHH:mm") : ""}
						/>
					</div>
				</div>

				<div className="tw-flex tw-flex-col">
					<label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Comentarios:</label>
					<div className="tw-flex tw-flex-col">
						<textarea
							id="entrega_comentarios"
							name="comentarios"
							cols="30"
							rows="3"
							maxLength="500"
							className="input-edit-sm tw-text-left tw-w-full tw-h-20"
							disabled={paquete.fecha_entrega}
						></textarea>
					</div>
				</div>

			</div>

			<div className="tw-flex tw-flex-col tw-self-start tw-items-center tw-justify-center tw-gap-3">
				<div className="tw-flex tw-flex-col tw-items-center tw-gap-1">
					<div className="tw-relative tw-w-47 tw-h-44 tw-overflow-hidden tw-rounded tw-shadow">
						<img
							src={foto_paquete_url || require('../../img/empty_image.png')}
							className="tw-w-full tw-h-full tw-object-contain"
							id="previewArea"
							alt="Preview paquete"
						/>
					</div>
				</div>

				<div className="tw-flex tw-flex-col tw-items-center tw-gap-1">
					<div className="tw-relative tw-w-47 tw-h-44 tw-overflow-hidden tw-rounded tw-shadow">
						<img
							src={foto_entrega_url || require('../../img/empty_image.png')}
							className="tw-w-full tw-h-full tw-object-contain"
							id="previewArea"
							alt="Preview entrega"
						/>

						{!paquete.fecha_entrega && (
							<label
								htmlFor="entrega_foto_entrega"
								className="tw-absolute tw-inset-0 tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-black tw-bg-opacity-50 tw-text-white tw-cursor-pointer tw-opacity-0 hover:tw-opacity-100 tw-transition tw-text-xs"
							>
								<i className="fas fa-file-upload tw-mb-1 tw-text-3xl"></i>
								<input
									type="file"
									id="entrega_foto_entrega"
									name="entrega_foto_entrega"
									accept="image/*"
									onChange={changePaqueteImagen}
									className="tw-hidden"
								/>
								<span>Subir imagen</span>
							</label>
						)}
					</div>
				</div>
			</div>
		</div>
	);

};

export default PaqueteForm;
